module.exports = __webpack_public_path__ + "static/media/main_logo.f083a789.png";